// extracted by mini-css-extract-plugin
export default {"tableContainer":"ServiceCategoriesPage_tableContainer__lXjiQ"};